import React, { useRef, useEffect } from "react";
import PropTypes from "prop-types";

function useOutsideAlerter(ref, props) {
  useEffect(() => {
    function handleClickOutside(event) {
  // debugger;
      if (ref.current && !ref.current.contains(event.target)
       && event.target.getAttribute("data-disableclick")==null
       && event.target.alt != "Close"
       && event.target.placeholder!="Select Date") {
        props.setIsClickedOutSide(true);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [ref]);
}

function OutsideAlerter(props) {
  const wrapperRef = useRef(null);
  useOutsideAlerter(wrapperRef, props);

  return props.className != null ? (
    <div className={props.className} ref={wrapperRef}>
      {props.children}
    </div>
  ) : (
    <div ref={wrapperRef}>{props.children}</div>
  );
}

OutsideAlerter.propTypes = {
  children: PropTypes.element.isRequired,
};

export default OutsideAlerter;
